import axios from "axios";

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
const ENVIRONMENT = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT;

const API_URL = `https://graphql.contentful.com/content/v1/spaces/${SPACE_ID}/environments/${ENVIRONMENT}`;

const contentfulQuery = async (query) => {
  const response = await axios.post(
    API_URL,
    { query },
    {
      headers: {
        Authorization: `Bearer ${ACCESS_TOKEN}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data.data;
};

export const fetchCityPairs = async () => {
  const query = `
    query {
      cityPairCollection(limit: 500) {
        items {
          departureStation {
            code
            name
          }
          arrivalStation {
            code
            name
          }
        }
      }
    }
  `;

  const data = await contentfulQuery(query);
  return data.cityPairCollection.items;
};

export const fetchAdvisoryBanners = async (locale = "en") => {
  const contentfulLocale = locale === "fr" ? "fr-CA" : "en-US";
  const query = `
    query {
      appTravelAdvisoryCollection(locale: "${contentfulLocale}") {
        items {
          title
          description
          variant
          showBanner
          showIcon
          learnMore {
            url
            name
          }
        }
      }
    }
  `;

  const data = await contentfulQuery(query);
  return data.appTravelAdvisoryCollection.items.filter((item) => item.showBanner);
};
